
import {map} from 'rxjs/operators';
import { QACompletedTicket, QualityGroupUsers } from './qaTicket';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable ,  of } from 'rxjs';
import { Router } from '@angular/router';
import { LocalStorage } from '../shared/localstorage.service';
import { reject } from 'q';
import { Ticket } from './ticket';
import { Http } from '@angular/http';

@Injectable()
export class TicketService {
    constructor(private http: HttpClient, private _router: Router, private localStorage: LocalStorage, private _http: Http) { }
    ticket = new Ticket();
    getTicket(number: string, token: string, state: string) {
        return new Promise<Ticket>(resolve => {
            this.http.get<Ticket>('/api/ticket/', {
                params: { number: number, gctoken: token, state: state }
            })
                .subscribe(data => {
                    this.ticket = data;
                    resolve(this.ticket);
                });
            setTimeout(() => resolve(this.ticket), 100000);
        });
    }
    getMyTickets(username: string, state: string): Observable<QACompletedTicket[]> {
        return this._http.get('/api/ticket/getmytickets', {
            params: { username: username, state: state }
        }).pipe(map(res =>
            res.json()));
    }

    getMyTicketsSearch(username: string, ticketNumber: string, startDate: string, endDate: string, criticalLevel: string, queueCategory: string, packetId: number, state: string): Observable<QACompletedTicket[]> {
        return this._http.get('/api/ticket/getmyticketssearch', {
            params: { username: username, ticketNumber: ticketNumber, startDate: startDate, endDate: endDate, criticalLevel: criticalLevel, queueCategory: queueCategory, packetId: packetId, state: state }
        }).pipe(map(res =>
            res.json()));
    }

    getActivityTickets(Activity: string, state: string): Observable<QACompletedTicket[]>{
        return this.http.get<QACompletedTicket[]>(`/api/ticket/getactivitytickets?Activity=${Activity}&State=${state}`);
    }

    getUsersByQualityGroup(gcToken: string, Property: string, state: string): Observable<QualityGroupUsers[]>{
        return this._http.get('/api/agentmanagement/agents', {
            params: { gcToken: gcToken, Property: Property, state: state }
        }).pipe(map(res =>res.json()));
    }

    getPacketNameById(packetId: number){
        
    }
}

